// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dLkm","label":"styles_label__YI-CH"};